export const CLIENT_SEARCH_HIDE_SERVICES_TEST_NAME = 'client_search_hideservices_atl3799_20210609';
export const CLIENT_SEARCH_HIDE_SERVICES_TEST_PERCENT = 0.5;
